import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function Home() {
    const reduxUser = useSelector(state => state.auth.user);
    const currentUser = reduxUser || window.wp_user;

    // 1. FRICTIONLESS GUEST FLOW:
    // Completely stripped out the forced window.location redirect block here.
    // Unauthenticated visitors are now fully welcome to explore the homepage freely!

    return (
        <div className="home">
            <div className="hero">
                <div className="box">
                    <div className="left">
                        <div className="HeroText"> 
                            <h1 className='title'>Color your Own <br /> Stained Glass</h1>
                            <h2>make a <b>unique window</b> in a few clicks!</h2> 
                            
                            {/* DYNAMIC WELCOME BANNER: Handles both guest states and authenticated profiles safely */}
                            <p style={{ fontSize: "1.2rem", color: "#28a745", fontWeight: "bold" }}>
                                {currentUser ? (
                                    `👋 Welcome back, ${currentUser.display_name || currentUser.email || 'Artist'}!`
                                ) : (
                                    "✨ Welcome to the Design Workspace!"
                                )}
                            </p>
                            
                            <div className="HeroButtons">
                                <div className="arrow-right" style={{ display: 'inline-block' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22.703" height="21.928">
                                        <path d="M1.056 21.928c0-6.531 5.661-9.034 10.018-9.375V18.1L22.7 9.044 11.073 0v4.836a10.5 10.5 0 0 0-7.344 3.352C-.618 12.946-.008 21 .076 21.928z" fill="green"/>
                                    </svg>
                                </div>
                                
<Link to="/images"> 
  <span 
    className="HeroButton" 
    style={{ background: "green", display: "inline-block", padding: "12px 24px" }}
  >
    Start Coloring Now
  </span> 
</Link>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <img className="hero-image" src="/glass-tool/color-your-own-stained-glass.webp" alt="Glass"/>
                    </div>
                </div>
            </div>
            
            <div className="HeroText2">    
                <p>Our <b>Click'N Color&trade;</b> online tool helps you create</p>
                <p>a window tailored to your needs within minutes</p>
            </div>
            
            <h2 className="steps-h2"> it's as easy as it can be!</h2>
            <div className="grid-container-3">
                <div className="grid-item"><p className="steps"><span className="circle">1</span>Select a design <br /><small className="small-steps">Professionally designed styles</small></p></div>
                <div className="grid-item"><p className="steps"><span className="circle">2</span>Customize it<br /><small className="small-steps">Change the Size, Form and Color</small></p></div>  
                <div className="grid-item"><p className="steps"><span className="circle">3</span>Get a Free Quote<br /><small className="small-steps">Get a Quote in minutes!</small></p></div>
            </div>
            
            <hr className="hr" />      
            <h2 className="steps-h2"> Ready to Get started?</h2>
            <p className="small-p-title">Just select one of our masterpiece designs to start customizing it online</p>
            <p className="p-title">Each of our award-winning designs features a unique Beveled Cluster Glass.</p>
            
            
            <hr className="hr" />   
            <div className="grid-container-2">
                <div className="grid-item">
                    <img className="image-fixed-color" alt="handcrafted" src="/glass-tool/handcrafted.jpg" />
                </div>
                <div className="grid-item">
                    <p className="small-p">Every panel is handmade right in our studio</p>
                    <h3>Handcrafted &#38;<br />Custom made <br /> Stained Glass</h3>
                    <div className="arrows">
                        <ul>
                            <li>Stained Glass at great Prices</li>
                            <li>High-quality materials</li>
                            <li>Fast Lead times</li>
                            <li>Crate Shipping for extra care</li>
                            <li>The easiest way for creating a unique piece</li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div className="grid-container-2">
                <div className="grid-item">
                    <p className="small-p">The perfect addition to any decor</p>
                    <h3>Enhance the look of<br />any room or space!</h3>
                </div>
                <div className="grid-item">
                    <img className="image-fixed-color" alt="enhance" src="/glass-tool/enhance.jpg" />
                </div>
            </div>
        </div>
    );
}